import React from 'react';
import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import { Loader } from '../../../../common/components';

const AddTableColumnPage = loadable(() => import('./AddTableColumnPage'), {
  fallback: <Loader />
});
const EditTableColumnPage = loadable(() => import('./EditTableColumnPage'), {
  fallback: <Loader />
});
const TableColumnRoute = ({ t, setTabLoading ,alert }) => {
  return [
    <Route
      key="database_table_column_add"
      exact
      path="/view/:projectId/database/:databaseId/table/:tableId/columns/add"
      element={<AddTableColumnPage t={t} setTabLoading={setTabLoading} alert={alert} />}
    />,
    <Route
      key="database_table_column_edit"
      exact
      path="/view/:projectId/database/:databaseId/table/:tableId/columns/:id/edit"
      element={<EditTableColumnPage t={t} setTabLoading={setTabLoading} alert={alert} />}
    />
  ];
};
TableColumnRoute.propTypes = {
  t: PropTypes.func
};
export default TableColumnRoute;
